import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import SignaturePad from "react-signature-canvas";
import { HeaderHome } from "./HeaderHome";
import { Footer } from "./Footer";
import {
  FaShare,
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaChevronDown,
} from "react-icons/fa";

export const Timesheet = () => {
  const currentYear = new Date().getFullYear();
  const [valueUserDetail, setValuegetuser] = useState([]);
  const [valueClient, setvalueClient] = useState([]);
  const [valueemployee, setvalueemployee] = useState([]);
  const [isClickedsuccess, setIsClickedSuccess] = useState(false);
  const [isClickedno, setIsClickedno] = useState(false);
  const [weekd, setweekd] = useState(false);
  const [isClickederror, setIsClickederror] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState("");
  const [successMessage, setsuccessMessage] = useState(false);
  const [spinners, setspinners] = useState(false);
  const isActive = true;
  const [startend, setstartend] = useState("");
  const [clname, setclname] = useState("");
  const [setarrvalue, setarr] = useState("");
  const [weekdetails, setweekdetails] = useState([]);
  const [weekarrdata, setweekarrdata] = useState([]);
  const [indx, setindx] = useState(null);
  const [signerror, setsignerror] = useState(false);
  const [supererror, setsupererror] = useState(false);
  const [activeindex, setactiveindex] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [selectedLocation, setSelectedLocation] = useState("");
  const [locations, setLocations] = useState([]);
  const [formDataa, setFormDataa] = useState([
    { email: "", message: "" },
    { email: "", message: "" },
  ]);
  const userStr = JSON.parse(localStorage.getItem("users"));
  const navigate = useNavigate();

  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };

  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    document.title = "Signature Page";
    const userStr = JSON.parse(localStorage.getItem("users"));
    if (userStr === null) {
      window.location.href = "#/login";
    }
    let formdata = {
      user_id: userStr[0].id,
    };
    axios
      .post("https://jlmining.app/admin/getuserdetails", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.row[0];
        setValuegetuser(alldata);
      })
      .catch((err) => { });

    const storedUserSearch = localStorage.getItem("userSearch");
    const userSearch = JSON.parse(storedUserSearch);

    if (userSearch === null) {
      var search = "";
    } else {
      var search = userSearch.search;
    }
    let formdatas = {
      user_id: userStr[0].id,
      search: search,
    };
    axios
      .post("https://jlmining.app/admin/getclientFuser", formdatas, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.results;
        setvalueClient(alldata);
        if (alldata.length > 0) {
          let formdataa = {
            user_id: userStr[0].id,
            client_id: alldata[0].client_id,
          };
          axios
            .post(
              "https://jlmining.app/users/getweeklytimesheetuser",
              formdataa,
              {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              setstartend(res.data.arr);
            })
            .catch((err) => { });
        }
      })
      .catch((err) => { });
  }, []);

  const apiUrlUser = "https://jlmining.app/api/users/";
  const [ClientId, setClientId] = useState("");
  const [indextype, setindextype] = useState("");
  const handlegetClientdata = (client_id, index, name) => {
    setSelectedLocation("");
    const userStr = JSON.parse(localStorage.getItem("users"));
    let formdata = {
      user_id: userStr[0].id,
      client_id: client_id,
    };
    setindx(index);
    setindextype(index);
    setclname(name);
    setClientId(client_id);
    setIsClickedno(false);
    setIsClicked(false);
    setarr("");
    setweekd(false);
    // Mock locations - replace with actual API call
    getClientLocations(userStr[0].id, client_id);
    axios
      .post("https://jlmining.app/admin/getEmployeeDetail", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.row != "" && res.data.row != undefined) {
          var alldata = res.data.row[0];
          setvalueemployee(alldata);
          //setIsClicked(true);
          //   setIsClickedno(false);
        }
        if (res.data.row == undefined || res.data.row.length == 0) {
          //setIsClicked(false);
          //setIsClickedno(true);
        }
      })
      .catch((err) => { });
    // axios
    //   .post("https://jlmining.app/users/getweeklytimesheetuser", formdata, {
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //     },
    //   })
    //   .then((res) => {
    //     setstartend(res.data.arr);
    //     if (res.data.arr.length > 0) {
    //       setarr("1");
    //     } else {
    //       setarr("");
    //     }
    //   })
    //   .catch((err) => {});
  };
  const getClientLocations = (userId, clientid) => {
    let formdata = {
      userId: userId,
      clientid: clientid,
    };
    axios
      .post(apiUrlUser + "getClientLocations", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLocations(res.data.results);
      })
      .catch((err) => { });
  };
  const [RosterId, setRosterId] = useState("");
  const handleformsubmit = (event) => {
    event.preventDefault();
    const vl = event.target;
    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL();

    if (canvasRef.current.isEmpty()) {
      setsignerror(true);
      return;
    } else {
      setsignerror(false);
    }
    if (vl.super_viser.value === "") {
      setsupererror(true);
      return;
    } else {
      setsupererror(false);
    }

    setSignatureDataURL(signatureData);

    if (vl.client_id.value) {
      let formdata = {
        client_id: vl.client_id.value,
        user_id: vl.user_id.value,
        start: weekarrdata.start,
        end: weekarrdata.end,
        location_id: selectedLocation,
        signature_img: signatureData,
        super_viser: vl.super_viser.value,
        rosterid: RosterId,
      };
      axios
        .post("https://jlmining.app/admin/employeAttendanceForm", formdata, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          setIsClicked(false);
          if (res.data.status == "2") {
            setIsClickederror(true);
            setIsClickedSuccess(false);
          } else {
            setIsClickederror(false);
            setIsClickedSuccess(true);
          }
          let senddata = {
            email: "",
            name: vl.super_viser.value,
            message: "",
            start_date: weekarrdata.start,
            end_date: weekarrdata.end,
            user_id: vl.user_id.value,
            roster_id: valueemployee.roster_id,
            client_id: valueemployee.client_id,
            location_id: valueemployee.location_id,
          };
          insertSign(senddata);
          setTimeout(() => {
            window.location.reload();
          }, 4500);
        })
        .catch((err) => { });
    }
  };

  const insertSign = (senddata) => {
    axios
      .post(
        "https://jlmining.app/api/adminsupervisor/sendtimeSheetForUserEnd",
        senddata,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => { })
      .catch((err) => { });
  };

  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  const clearCanvas = () => {
    canvasRef.current.clear();
  };

  const captureSignature = () => {
    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL();
    setSignatureDataURL(signatureData);
  };

  const apiurl = "https://jlmining.app/uploads/";
  var imageUrl = `${apiurl}${valueUserDetail.image}`;
  if (valueUserDetail.image == null) {
    var im = "male-upload.png";
    var imageUrl = `${apiurl}${im}`;
  } else {
    var imageUrl = `${apiurl}${valueUserDetail.image}`;
  }

  const getuserweeklydata = (index, start, end, user_id) => {
    let data = {
      start: start,
      end: end,
      user_id: user_id,
    };
    setactiveindex(null);
    setActiveTimeSheetIndex(index);
    setweekarrdata(data);
    axios
      .post("https://jlmining.app/user/getuserweeklydataclient", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.data.length > 0) {
          setweekd(true);
          console.log(res.data.data);
          setweekdetails(res.data.data);
        } else {
          setweekd(false);
        }
      })
      .catch((err) => { });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const sendShare = (
    index,
    start,
    end,
    user_id,
    roster_id,
    client_id,
    location_id
  ) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const email = formDataa[index]?.email?.trim() || "";
    const message = formDataa[index]?.message?.trim() || "";
    const emailEmpty = email === "";
    const emailInvalid = !emailEmpty && !emailRegex.test(email);
    const messageEmpty = message === "";

    setValidationErrors((prev) => ({
      ...prev,
      [index]: {
        email: emailEmpty || emailInvalid,
        emailMessage: emailEmpty
          ? "This field is required"
          : emailInvalid
            ? "Invalid email format"
            : "",
        message: messageEmpty,
      },
    }));

    if (!emailEmpty && !emailInvalid && !messageEmpty) {
      let senddata = {
        email: email,
        message: message,
        start_date: start,
        end_date: end,
        user_id: user_id,
        roster_id: roster_id,
        client_id: client_id,
        location_id: location_id,
      };
      setspinners(true);
      axios
        .post(
          "https://jlmining.app/api/adminsupervisor/sendtimeSheet",
          senddata,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          setspinners(false);
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        })
        .catch((err) => { });
    }
  };

  const [activeTimeSheetIndex, setActiveTimeSheetIndex] = useState(null);
  const handleopenshare = (index) => {
    setactiveindex((prevIndex) => (prevIndex === index ? null : index));
    setweekd(false);
  };

  const handleEmailInput = (index, value) => {
    setFormDataa((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        email: value,
      },
    }));
  };

  const handleMessageInput = (index, value) => {
    setFormDataa((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        message: value,
      },
    }));
  };
  const GetTimesheet = (e) => {
    let formData = {
      client_id: ClientId,
      location_id: e,
      user_id: userStr[0].id,
    };
    setSelectedLocation(e);
    //setindx(indextype);
    axios
      .post("https://jlmining.app/users/getweeklytimesheetuser", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setstartend(res.data.arr);
        if (res.data.arr.length > 0) {
          var dataset = res.data.arr[0];
          setRosterId(dataset.roster_id);
          setIsClicked(true);
          setarr("1");
        } else {
          setIsClicked(false);
          setarr("");
        }
      })
      .catch((err) => { });
  };
  return (
    <>
      <HeaderHome />
      <section className="innerbanner text-center py-5 d-block">
        <div className="container-lg">
          <h3 className="fs-30 fw-800 text-white">Signature</h3>
        </div>
      </section>

      {/* Enhanced Profile Section */}
      <section
        className="profile-box d-block"
        style={{
          background: "linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%)",
        }}
      >
        <div className="container-lg">
          <div className="row gy-4 align-items-center">
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-3 text-center">
                <div
                  className="position-relative mx-auto"
                  style={{ width: "fit-content" }}
                >
                  <div
                    className="emplo-box-pic ofit mx-auto shadow-lg"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "4px solid #fff",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                    }}
                  >
                    <img
                      src={imageUrl}
                      alt="profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div
                    className="position-absolute bottom-0 end-0 bg-success rounded-circle"
                    style={{
                      width: "30px",
                      height: "30px",
                      border: "3px solid white",
                    }}
                  ></div>
                </div>
                <div className="d-flex flex-column">
                  <h3 className="fs-24 text-black fw-800 mb-1">
                    {valueUserDetail.first_name} {valueUserDetail.middle_name}{" "}
                    {valueUserDetail.last_name}
                  </h3>
                  <p className="fs-16 text-muted fw-500">
                    {valueUserDetail.role}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row gy-3">
                <div className="col-lg-6">
                  <div
                    className="p-3 rounded-3"
                    style={{
                      background: "#f8f9fa",
                      border: "1px solid #e9ecef",
                    }}
                  >
                    <p
                      className="text-muted mb-1 fw-600"
                      style={{ fontSize: "12px" }}
                    >
                      PHONE NUMBER
                    </p>
                    <h4 className="fs-16 text-black fw-600 mb-0">
                      {valueUserDetail.contact}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div
                    className="p-3 rounded-3"
                    style={{
                      background: "#f8f9fa",
                      border: "1px solid #e9ecef",
                    }}
                  >
                    <p
                      className="text-muted mb-1 fw-600"
                      style={{ fontSize: "12px" }}
                    >
                      EMAIL ADDRESS
                    </p>
                    <h4
                      className="fs-16 text-black fw-600 mb-0"
                      style={{ wordBreak: "break-word" }}
                    >
                      {valueUserDetail.email}
                    </h4>
                  </div>
                </div>
                <div className="col-12">
                  <div
                    className="p-3 rounded-3"
                    style={{
                      background: "#f8f9fa",
                      border: "1px solid #e9ecef",
                    }}
                  >
                    <p
                      className="text-muted mb-1 fw-600"
                      style={{ fontSize: "12px" }}
                    >
                      ADDRESS
                    </p>
                    <h4 className="fs-16 text-black fw-600 mb-0">
                      {valueUserDetail.address}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Main Content Section */}
      <section
        className="d-block py-5"
        style={{ minHeight: "100vh", background: "#fafbfc" }}
      >
        <div className="container-lg">
          <div className="row gy-4">
            {/* Sidebar - Client & Location Selection */}
            <div className="col-lg-3">
              <div className="sticky-top" style={{ top: "20px" }}>
                <div
                  className="bg-white rounded-4 shadow-sm p-4"
                  style={{ border: "1px solid #e9ecef" }}
                >
                  <h3 className="text-black fs-20 fw-bold mb-4">
                    <FaMapMarkerAlt className="me-2 text-primary" />
                    Select Client
                  </h3>

                  <div className="d-flex flex-column gap-2">
                    {Array.isArray(valueClient) && valueClient.length > 0 ? (
                      valueClient.map((item, index) => (
                        <Link
                          key={index}
                          to="javascript:void(0)"
                          onClick={() =>
                            handlegetClientdata(
                              item.client_id,
                              index,
                              item.name
                            )
                          }
                          className={`client-btn-enhanced d-block px-4 py-3 rounded-3 text-decoration-none transition-all ${index === indx && isActive
                              ? "bg-primary text-white shadow-sm"
                              : "bg-light text-dark hover-shadow"
                            }`}
                          style={{
                            border:
                              index === indx && isActive
                                ? "none"
                                : "1px solid #e9ecef",
                            transition: "all 0.3s ease",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          {item.name}
                        </Link>
                      ))
                    ) : (
                      <p className="text-muted text-center py-3">
                        No clients available
                      </p>
                    )}
                  </div>

                  {/* Location Dropdown */}
                  {locations.length > 0 && (
                    <div
                      className="mt-4 pt-4"
                      style={{ borderTop: "2px solid #e9ecef" }}
                    >
                      <label className="text-black fs-14 fw-bold mb-3 d-block">
                        <FaMapMarkerAlt className="me-2 text-success" />
                        Select Location
                      </label>
                      <div className="position-relative">
                        <select
                          value={selectedLocation}
                          onChange={(e) => GetTimesheet(e.target.value)}
                          className="form-select form-select-lg rounded-3 shadow-sm"
                          style={{
                            border: "2px solid #e9ecef",
                            padding: "12px 40px 12px 16px",
                            fontSize: "14px",
                            fontWeight: "600",
                            cursor: "pointer",
                            appearance: "none",
                            background: "#fff",
                          }}
                        >
                          <option value="">Choose a location...</option>
                          {locations.map((location) => (
                            <option key={location.id} value={location.id}>
                              {location.location_name}
                            </option>
                          ))}
                        </select>
                        <FaChevronDown
                          className="position-absolute text-muted"
                          style={{
                            right: "16px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Main Content Area */}
            <div className="col-lg-9">
              <div className="d-flex flex-column gap-4">
                {/* No Results Message */}
                {setarrvalue === "" && indx !== null && (
                  <div
                    className="bg-white rounded-4 shadow-sm p-5 text-center"
                    style={{ border: "1px solid #e9ecef" }}
                  >
                    <div className="mb-3">
                      <FaCalendarAlt size={48} className="text-muted" />
                    </div>
                    <h4 className="text-black fs-18 fw-600 mb-2">
                      No Timesheets Found
                    </h4>
                    <p className="text-muted mb-0">
                      There are no timesheets available for this client.
                    </p>
                  </div>
                )}

                {/* Success Message */}
                {successMessage && (
                  <div
                    className="alert alert-success rounded-4 shadow-sm d-flex align-items-center"
                    style={{ border: "none" }}
                  >
                    <div className="me-3">
                      <svg
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <span className="fw-600">Email successfully sent!</span>
                  </div>
                )}

                {/* Timesheets List */}
                {setarrvalue != "" && (
                  <div className="d-flex flex-column gap-3">
                    <div
                      className="bg-white rounded-4 shadow-sm p-4"
                      style={{ border: "1px solid #e9ecef" }}
                    >
                      <h4 className="text-black fs-18 fw-bold mb-4">
                        <FaClock className="me-2 text-primary" />
                        Available Timesheets
                      </h4>

                      {Array.isArray(startend) && startend.length > 0 ? (
                        startend.map((item, index) => (
                          <div
                            key={index}
                            className={`timesheet-card mb-3 p-4 rounded-3 transition-all ${index === activeTimeSheetIndex
                                ? "border-primary"
                                : ""
                              }`}
                            style={{
                              border:
                                index === activeTimeSheetIndex
                                  ? "2px solid #0d6efd"
                                  : "1px solid #e9ecef",
                              background:
                                index === activeTimeSheetIndex
                                  ? "#f8f9ff"
                                  : "#fff",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <Link
                                className="text-decoration-none flex-grow-1"
                                to="javascript:void(0)"
                                onClick={() =>
                                  getuserweeklydata(
                                    index,
                                    item.start,
                                    item.end,
                                    item.user_id
                                  )
                                }
                              >
                                <div className="d-flex align-items-center gap-3">
                                  <div
                                    className="p-3 rounded-3"
                                    style={{ background: "#e7f3ff" }}
                                  >
                                    <FaCalendarAlt
                                      size={24}
                                      className="text-primary"
                                    />
                                  </div>
                                  <div>
                                    <p
                                      className="text-muted mb-1 fw-600"
                                      style={{ fontSize: "12px" }}
                                    >
                                      TIMESHEET PERIOD
                                    </p>
                                    <h5
                                      className="text-black fw-bold mb-0"
                                      style={{ fontSize: "15px" }}
                                    >
                                      {formatDate(item.start)} -{" "}
                                      {formatDate(item.end)}
                                    </h5>
                                  </div>
                                </div>
                              </Link>
                              <button
                                onClick={() => handleopenshare(index)}
                                className="btn btn-light rounded-circle p-3 ms-3"
                                type="button"
                                title="Share"
                                style={{ width: "45px", height: "45px" }}
                              >
                                <FaShare size={16} />
                              </button>
                            </div>

                            {/* Share Form */}
                            {index === activeindex && (
                              <div
                                className="mt-4 p-4 rounded-3"
                                style={{
                                  background: "#fff",
                                  border: "2px dashed #dee2e6",
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h5 className="fw-bold mb-0">
                                    Share Timesheet
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setactiveindex(null)}
                                  ></button>
                                </div>

                                <div className="mb-3">
                                  <label className="form-label fw-600">
                                    Email Address
                                  </label>
                                  <input
                                    type="email"
                                    className="form-control form-control-lg"
                                    placeholder="Enter email address"
                                    defaultValue={formDataa[index]?.email || ""}
                                    onChange={(e) =>
                                      handleEmailInput(index, e.target.value)
                                    }
                                    style={{
                                      border: "2px solid #e9ecef",
                                      borderRadius: "8px",
                                    }}
                                  />
                                  {validationErrors[index]?.email && (
                                    <small className="text-danger mt-2 d-block">
                                      {validationErrors[index]?.emailMessage}
                                    </small>
                                  )}
                                </div>

                                <div className="mb-4">
                                  <label className="form-label fw-600">
                                    Message
                                  </label>
                                  <textarea
                                    className="form-control"
                                    placeholder="Enter your message..."
                                    rows={4}
                                    defaultValue={
                                      formDataa[index]?.message || ""
                                    }
                                    onChange={(e) =>
                                      handleMessageInput(index, e.target.value)
                                    }
                                    style={{
                                      border: "2px solid #e9ecef",
                                      borderRadius: "8px",
                                    }}
                                  />
                                  {validationErrors[index]?.message && (
                                    <small className="text-danger mt-2 d-block">
                                      This field is required
                                    </small>
                                  )}
                                </div>

                                <div className="d-flex gap-2">
                                  <button
                                    style={{
                                      opacity: spinners ? 0.5 : 1,
                                      pointerEvents: spinners ? "none" : "auto",
                                    }}
                                    className="btn btn-primary px-4 py-2 fw-600"
                                    onClick={() =>
                                      sendShare(
                                        index,
                                        item.start,
                                        item.end,
                                        item.user_id,
                                        item.roster_id,
                                        item.client_id,
                                        item.location_id
                                      )
                                    }
                                  >
                                    {spinners ? "Sending..." : "Send Email"}
                                  </button>
                                  {spinners && (
                                    <div
                                      className="spinner-border text-primary"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <p className="text-muted text-center py-3">
                          No timesheets available
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* Weekly Details & Signature Form */}
                {weekd && (
                  <div
                    className="bg-white rounded-4 shadow-sm p-4"
                    style={{ border: "1px solid #e9ecef" }}
                  >
                    {/* Week Details Table */}
                    <div className="table-responsive mb-4">
                      <table className="table table-hover">
                        <thead style={{ background: "#f8f9fa" }}>
                          <tr>
                            <th className="fw-bold py-3">Roster</th>
                            <th className="fw-bold py-3">Day</th>
                            <th className="fw-bold py-3">Date</th>
                            <th className="fw-bold py-3">Hours</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(weekdetails) &&
                            weekdetails.map((item, index) => (
                              <tr key={index}>
                                <td className="py-3 fw-600">{item.roster}</td>
                                <td className="py-3 fw-600">{item.dd}</td>
                                <td className="py-3">{item.nd}</td>
                                <td className="py-3">
                                  <span className="badge bg-primary px-3 py-2">
                                    {item.hours}
                                  </span>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Signature Form */}
                    {setarrvalue != "" && (
                      <form
                        action="javascript:void(0)"
                        onSubmit={handleformsubmit}
                        method="post"
                      >
                        <input
                          type="hidden"
                          name="client_id"
                          value={valueemployee.client_id}
                        />
                        <input
                          type="hidden"
                          name="attend_id"
                          value={valueemployee.id}
                        />
                        <input
                          type="hidden"
                          name="user_id"
                          value={valueemployee.user_id}
                        />
                        <input
                          type="hidden"
                          name="hours"
                          value={valueemployee.hours}
                        />

                        {/* Client Name */}
                        <div
                          className="mb-4 p-3 rounded-3"
                          style={{
                            background: "#f8f9fa",
                            border: "1px solid #e9ecef",
                          }}
                        >
                          <label
                            className="text-muted mb-1 fw-600"
                            style={{ fontSize: "12px" }}
                          >
                            CLIENT NAME
                          </label>
                          <h5 className="text-black fw-bold mb-0">{clname}</h5>
                        </div>

                        {/* Signature Section */}
                        <div className="mb-4">
                          <h5 className="text-black fw-bold mb-3">
                            Supervisor Signature *
                          </h5>
                          <div
                            className="signature-canvas-wrapper rounded-3 overflow-hidden shadow-sm"
                            style={{ border: "2px solid #e9ecef" }}
                          >
                            <SignaturePad
                              ref={canvasRef}
                              canvasProps={{
                                style: {
                                  width: "100%",
                                  height: "200px",
                                  background: "#fafbfc",
                                },
                              }}
                            />
                          </div>
                          {signerror && (
                            <small className="text-danger mt-2 d-block">
                              <svg
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="me-1"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                              </svg>
                              Signature is required
                            </small>
                          )}
                        </div>

                        {/* Supervisor Name */}
                        <div className="mb-4">
                          <label className="form-label fw-bold">
                            Supervisor Name *
                          </label>
                          <input
                            type="text"
                            name="super_viser"
                            className="form-control form-control-lg"
                            placeholder="Enter supervisor name..."
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                            }}
                          />
                          {supererror && (
                            <small className="text-danger mt-2 d-block">
                              <svg
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="me-1"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                              </svg>
                              This field is required
                            </small>
                          )}
                        </div>

                        {/* Action Buttons */}
                        <div
                          className="d-flex justify-content-end gap-3 pt-3"
                          style={{ borderTop: "2px solid #e9ecef" }}
                        >
                          <button
                            onClick={clearCanvas}
                            className="btn btn-outline-secondary px-4 py-2 fw-600"
                            type="button"
                            style={{ borderRadius: "8px" }}
                          >
                            Clear Signature
                          </button>
                          <button
                            type="submit"
                            onClick={captureSignature}
                            className="btn btn-primary px-5 py-2 fw-600"
                            style={{ borderRadius: "8px" }}
                          >
                            Submit Timesheet
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                )}

                {/* Success Message */}
                {isClickedsuccess && (
                  <div
                    className="bg-white rounded-4 shadow-sm p-5 text-center"
                    style={{ border: "2px solid #28a745" }}
                  >
                    <div className="mb-3">
                      <svg
                        width="64"
                        height="64"
                        fill="#28a745"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <h3 className="text-success fs-20 fw-800 mb-2">Success!</h3>
                    <p className="text-muted mb-0">
                      You have successfully submitted your timesheet
                    </p>
                  </div>
                )}

                {/* Error Message */}
                {isClickederror && (
                  <div
                    className="bg-white rounded-4 shadow-sm p-5 text-center"
                    style={{ border: "2px solid #dc3545" }}
                  >
                    <div className="mb-3">
                      <svg
                        width="64"
                        height="64"
                        fill="#dc3545"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                      </svg>
                    </div>
                    <h3 className="text-danger fs-20 fw-800 mb-2">Error!</h3>
                    <p className="text-muted mb-0">
                      There was an error submitting your timesheet
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .client-btn-enhanced:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
        }

        .hover-shadow:hover {
          background: #f8f9fa !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
        }

        .transition-all {
          transition: all 0.3s ease;
        }

        .timesheet-card:hover {
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
        }

        .form-control:focus,
        .form-select:focus {
          border-color: #0d6efd !important;
          box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25) !important;
        }

        .table-hover tbody tr:hover {
          background-color: #f8f9fa;
        }

        .signature-canvas-wrapper canvas {
          cursor: crosshair;
        }
      `}</style>

      <Footer />
    </>
  );
};
